module.exports = __webpack_public_path__ + "static/media/masonprofile.22e587c0.jpg";